import type {
  OrderBy,
  SearchMetaOptions,
  ServerSearchMetaOptions,
} from '../types'

export const mapSearchMetaOptionsToQuery = (
  local: SearchMetaOptions,
): ServerSearchMetaOptions => {
  const { orderBy, ...rest } = local
  const stringOrderBy = orderBy.map(orderByToString)

  return {
    orderBy: stringOrderBy,
    ...rest,
  }
}

const orderByToString = (orderBy: OrderBy): string =>
  `${orderBy.field} ${orderBy.sort}`
